import { render, staticRenderFns } from "./AlertFeedItem.vue?vue&type=template&id=f21bf3d0&scoped=true&"
import script from "./AlertFeedItem.vue?vue&type=script&lang=ts&"
export * from "./AlertFeedItem.vue?vue&type=script&lang=ts&"
import style0 from "./AlertFeedItem.vue?vue&type=style&index=0&id=f21bf3d0&lang=scss&scoped=true&"
import style1 from "./AlertFeedItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21bf3d0",
  null
  
)

export default component.exports